export const PAGE_TEXT = {
  PAGE_DESCRIPTION:
    'This page indicates that you are invited by the following academic staffs for your research degree supervision. You may communicate with the corresponding staff for more information about the intake. Please consider to make the choice as soon to proceed your application. However, once the selection is made, your choice of academic supervisor will be overridden.',
  PAGE_GUIDE_1: 'Please Choose Your Preferred Supervisor',
  PAGE_GUIDE_2: 'See more detail about the supervisor(s)',
  PAGE_REMINEDER_1:
    '* Your choice is crucial as it will determine the next steps in your academic journey.',
  PAGE_REMINEDER_2:
    '* Once you make your selection, the chosen supervisor will be notified, and other potential supervisors will be informed of your decision.',
  ACCEPT_THE_INVITATION: 'Accept the Invitation',
  CONFIRM_INVITATION: 'Confirm Supervisor Selection',
  CONFIRM_INVITATION_CONTENT:
    'Please confirm your selection of this supervisor. Once you proceed, your choice will be finalized and the selected supervisor will be officially notified. Note that this decision is final and cannot be reversed.',
  HAVE_ACCEPTED: 'You have accepted the invitation',
};
